export default "__VITE_ASSET__3QCp$0dt__"